import { GoogleLogin } from "react-google-login";
import { config } from "../../../config";
import google_logo_icon from "../../../img/google_icon.svg";
import { FormattedMessage, useIntl } from "react-intl";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import facebook_logo_icon from "../../../img/facebook_logo.svg";
import React from "react";
import { Button, Box, useTheme } from "@mui/material";
import {
  LOGIN_FACEBOOK,
  REGISTER_GOOGLE,
} from "../../../apollo-client/mutations";
import { showErrorToast } from "../../../toast/toast-service";
import { useApolloClient } from "@apollo/client";

export const SSORegisterSocialButtons = ({
  provider,
  formValues,
  checkFormFilledForSocial,
  closeSidebar,
}) => {
  const apolloClient = useApolloClient();
  const intl = useIntl();
  const theme = useTheme();

  const checkFormFilledAndPerformOAuth = (performOAuth) => {
    const areRequiredInputsFilled = checkFormFilledForSocial();
    if (areRequiredInputsFilled) {
      performOAuth();
    }
  };

  const registerWithGoogle = async ({ accessToken }) => {
    try {
      const {
        data: { registerGoogle },
      } = await apolloClient.mutate({
        mutation: REGISTER_GOOGLE,
        variables: {
          accessToken,
          universities: [formValues.university],
          degreePrograms: [formValues.degreeProgram],
        },
      });

      localStorage.setItem("token", registerGoogle.jwt);
      window.location.reload();
    } catch (error) {
      showErrorToast(
        intl.formatMessage({ id: "register-continue-with-google-error" })
      );
    }
  };

  const registerWithFacebook = async ({ accessToken }) => {
    try {
      const {
        data: { registerFacebook },
      } = await apolloClient.mutate({
        mutation: LOGIN_FACEBOOK,
        variables: {
          accessToken,
          universities: [formValues.university],
          degreePrograms: [formValues.degreeProgram],
        },
      });

      localStorage.setItem("token", registerFacebook.jwt);
      window.location.reload();
    } catch (error) {
      showErrorToast(
        intl.formatMessage({ id: "register-continue-with-facebook-error" })
      );
    }
  };

  const onGoogleLoginError = () => {
    showErrorToast(
      intl.formatMessage({ id: "register-continue-with-google-error" })
    );
  };

  const onFacebookLoginError = () => {
    showErrorToast(
      intl.formatMessage({ id: "register-continue-with-facebook-error" })
    );
  };

  if (provider === "google") {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, width: '100%' }}>
        <GoogleLogin
          clientId={config.googleOAuthClientID}
          buttonText="Continue with Google"
          onSuccess={registerWithGoogle}
          onFailure={onGoogleLoginError}
          render={(renderProps) => (
            <Button
              onClick={() => {
                checkFormFilledAndPerformOAuth(renderProps.onClick);
              }}
              variant="outlined"
              startIcon={
                <img 
                  src={google_logo_icon} 
                  alt="Google"
                  style={{ width: '20px', height: '20px' }}
                />
              }
              sx={{
                width: '100%',
                maxWidth: '320px',
                height: '48px',
                textTransform: 'none',
                fontSize: '14px',
                fontWeight: 600,
                color: theme.palette.grey[700],
                borderColor: 'rgba(232, 121, 117, 0.2)',
                borderRadius: '12px',
                padding: '12px 20px',
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                backdropFilter: 'blur(10px)',
                border: '2px solid rgba(232, 121, 117, 0.1)',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                '&:hover': {
                  borderColor: 'rgba(232, 121, 117, 0.4)',
                  backgroundColor: 'rgba(255, 255, 255, 0.95)',
                  transform: 'translateY(-1px)',
                  boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                },
                transition: 'all 0.3s ease',
              }}
            >
              <FormattedMessage id="sign-up.continue-with-google" />
            </Button>
          )}
        />
      </Box>
    );
  }

  if (provider === "facebook") {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, width: '100%' }}>
        <FacebookLogin
          appId={config.facebookOAuthAppId}
          autoLoad={false}
          fields="name,email,picture"
          callback={registerWithFacebook}
          onFailure={onFacebookLoginError}
          size={"small"}
          render={(renderProps) => (
            <Button
              onClick={() => {
                checkFormFilledAndPerformOAuth(renderProps.onClick);
              }}
              variant="outlined"
              startIcon={
                <img 
                  src={facebook_logo_icon} 
                  alt="Facebook"
                  style={{ width: '20px', height: '20px' }}
                />
              }
              sx={{
                width: '100%',
                maxWidth: '320px',
                height: '48px',
                textTransform: 'none',
                fontSize: '14px',
                fontWeight: 600,
                color: theme.palette.grey[700],
                borderColor: 'rgba(232, 121, 117, 0.2)',
                borderRadius: '12px',
                padding: '12px 20px',
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                backdropFilter: 'blur(10px)',
                border: '2px solid rgba(232, 121, 117, 0.1)',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                '&:hover': {
                  borderColor: 'rgba(232, 121, 117, 0.4)',
                  backgroundColor: 'rgba(255, 255, 255, 0.95)',
                  transform: 'translateY(-1px)',
                  boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                },
                transition: 'all 0.3s ease',
              }}
            >
              <FormattedMessage id="sign-up.continue-with-facebook" />
            </Button>
          )}
        />
      </Box>
    );
  }

  return null;
};

